import { render, staticRenderFns } from "./ProductAddedToCartModal.vue?vue&type=template&id=2a0ce88d"
import script from "./ProductAddedToCartModal.vue?vue&type=script&lang=js"
export * from "./ProductAddedToCartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports